import './index.css'
import Button from '../button'
import { useState } from 'react';
import { requestPasswordReset } from '../../functions/requestPasswordReset';

function ResetPasswordmodule(){
    const [submitted,setSubmitted] = useState(false);
    const handleClick = () => {
        requestPasswordReset(document.getElementById("reset-password-email").value);
        setSubmitted(true);
    }
    return (
        <div className='reset-password-module'>
            <div className='small-text'>
                {submitted 
                    ? "Your reset password request has been submitted." 
                    : "Enter your email to reset your password"}
            </div>
            {submitted ? (
                <div className='small-text'>Please check your email for further instructions.</div>
            ) : (
                <input type='email' id="reset-password-email" />
            )}
            {!submitted && <Button text="Reset password" addedFunction={handleClick} />}
        </div>
)
}

export default ResetPasswordmodule